import createContext from 'bz-utilities/hooks/context-v2';
import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import type { ServiceTypeResponse } from '../../api.dtos';

export const [ServicesStoreCtx, useServicesStore] = createContext<ServicesStore>('servicesStore');

class ServicesStore extends CacheStore<ServiceTypeResponse> {
  constructor() {
    super('services');
  }
}

export default ServicesStore;
